import { render, staticRenderFns } from "./Advertiser.vue?vue&type=template&id=384e795c&scoped=true"
import script from "./Advertiser.vue?vue&type=script&lang=js"
export * from "./Advertiser.vue?vue&type=script&lang=js"
import style0 from "./Advertiser.vue?vue&type=style&index=0&id=384e795c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e795c",
  null
  
)

export default component.exports